import ApiRequest from "@/helpers/ApiRequest";
import GetHeaders from "@/helpers/GetHeaders";
import {
  SOCKET_ONOPEN,
  SOCKET_ONCLOSE,
  SOCKET_ONERROR,
  SOCKET_ONMESSAGE,
  SOCKET_RECONNECT,
  SOCKET_RECONNECT_ERROR,
  TOGGLE_CHATBOT_STATE,
  TOGGLE_CHATBOT_READY,
  SET_CHATBOT_THREAD
} from "@/store/mutation-types";

export default {
  actions: {
    initiateChatbot: async ({dispatch},payload) => {
      return ApiRequest.explorePost("initialize_chatbot", payload, GetHeaders.dataHeaders()).then(
        res => {
          dispatch("setChatbotStatus", 1);
          return res.data;
        }
      );
    },
    chatbotStatus: async ({dispatch},payload) => {
      return ApiRequest.exploreGet("indexing_status/" + payload.model_id, GetHeaders.dataHeaders()).then(
        res => {
          dispatch("setChatbotStatus", res.data.processing_state);
          return res.data;
        }
      );
    },
    resetChatbot: async (_,payload) => {
      return ApiRequest.explorePost("reset_chatbot", payload, GetHeaders.dataHeaders()).then(
        res => {
          return res.data;
        }
      );
    },
    queryChatbot: async (payload) => {
      return ApiRequest.explorePost("query_chatbot", payload, GetHeaders.dataHeaders()).then(
        res => {
        }
      );
    },
    getThreadMessages: async (_, payload) => {
      return ApiRequest.exploreGet("chat_history/" + payload.model_id + "/" + payload.session_id, GetHeaders.dataHeaders()).then(
        res => {
          return res.data
        }
      );
    },
    resetChatbotHistory: async (_,payload) => {
      return ApiRequest.explorePost("reset_history", payload, GetHeaders.dataHeaders()).then(
        res => {
          return res.data
        }
      );
    },
    loadThreads: async (_,payload) => {
      return ApiRequest.exploreGet("threads/" + payload.model_id, GetHeaders.dataHeaders()).then(
        res => {
          return res.data
        }
      );
    },
    deleteThread: async (_,payload) => {
      return ApiRequest.exploreDelete("delete_thread/" + payload.model_id + "/" + payload.session_id, GetHeaders.dataHeaders()).then(
        res => {
          return res.data
        }
      );
    },
    toggleChatBotState: async ({commit}) => {
      commit(TOGGLE_CHATBOT_STATE);
    },
    setChatbotStatus: async ({commit}, payload) => {
      commit(TOGGLE_CHATBOT_READY, payload)  
    },
    setChatbotThread: async ({commit}, payload) => {
      commit(SET_CHATBOT_THREAD, payload)  
    },
    setChatbotMessage: async ({commit}, payload) => {
      commit(SOCKET_ONMESSAGE, { message: payload })  
    }
  },
  getters: {},
  mutations: {
    [TOGGLE_CHATBOT_STATE](state) {
      state.chatbotState = !state.chatbotState;
    },
    [TOGGLE_CHATBOT_READY](state, payload) {
      state.chatbotReady = payload;
    },
    [SET_CHATBOT_THREAD](state, payload) {
      state.currentThread = payload;
    },
    [SOCKET_ONOPEN](state, event)  {
      state.socket.isConnected = true
    },
    [SOCKET_ONCLOSE](state, event)  {
      state.socket.isConnected = false
    },
    [SOCKET_ONERROR](state, event)  {
      console.error(state, event)
    },
    // default handler called for all methods
    [SOCKET_ONMESSAGE](state, message)  {
      state.socket.message = message.message || message.error
    },
    // mutations for reconnect methods
    [SOCKET_RECONNECT](state, count) {
      console.info(state, count)
    },
    [SOCKET_RECONNECT_ERROR](state) {
      state.socket.reconnectError = true;
    }
  },
  state: {
    chatbotState: false,
    chatbotReady: 0,
    currentThread: null,
    socket: {
      isConnected: false,
      message: '',
      reconnectError: false,
    }
  }
};
